import { Link, Outlet } from 'react-router-dom';

import { routes } from '@/app/router/route-paths';
import { Logo } from '@/features/storefront/components/Logo';

/**
 * Auth chrome for the storefront (login / register / OTP / password reset).
 * Deliberately plain — the brand mark, one centered card, nothing else — so it
 * reads the same as the admin sign-in screen.
 */
export function AuthLayout() {
  return (
    <main className="grid min-h-screen place-items-center bg-[var(--app-bg)] px-4 py-10">
      <div className="w-full max-w-md">
        <div className="flex justify-center">
          <Logo />
        </div>

        <div className="mt-6 rounded-2xl border bg-[var(--app-surface)] p-6 shadow-[var(--shadow-soft)] sm:p-8">
          <Outlet />
        </div>

        <p className="mt-6 text-center text-sm">
          <Link to={routes.home} className="text-[var(--app-muted)] hover:text-gold-700">
            ← Back to the store
          </Link>
        </p>
      </div>
    </main>
  );
}
